// Published snapshot — do not edit after this date ships. A content change
// becomes a new dated file (see index.ts), so a past visitor's version stays
// reconstructable instead of being silently rewritten in place.
import { Section } from './shared'

export default function Privacy20260831() {
  return (
    <>
      <p className="text-sm sm:text-base">
        Ova Politika privatnosti donosi se u skladu sa <strong>Zakonom o zaštiti podataka o ličnosti</strong> (&quot;Sl. glasnik RS&quot;, br. 87/2018 — ZZPL). Svrha ovog dokumenta je da transparentno objasni kako platforma <em>waterworks.rs</em> prikuplja, obrađuje, čuva i štiti podatke o ličnosti.
      </p>

      <hr className="border-gray-100" />

      <Section title="1. Uloge u obradi podataka (Rukovalac i Obrađivač)">
        <p className="text-sm">Zbog prirode platforme, uloge u obradi podataka su jasno podeljene:</p>
        <ul className="list-disc pl-5 space-y-2 text-sm">
          <li>
            <strong>Rukovalac podataka (Klijenti - Zakupci/Tenants):</strong> Za podatke krajnjih korisnika (potrošača/platiša) i zaposlenih kod klijenata (čitači vodomera, dispečeri, operateri), isključivi Rukovalac podataka je organizacija (komunalno preduzeće/vodovod) koja koristi platformu.
          </li>
          <li>
            <strong>Obrađivač podataka (I-SOFT MIONICA):</strong> Kreator platforme <em>waterworks.rs</em> nastupa isključivo kao Obrađivač za podatke Klijenata. Softver i baza podataka se pružaju kao usluga, a I-SOFT MIONICA nema pravo da koristi te podatke u sopstvene svrhe.
          </li>
          <li>
            <strong>Rukovalac podataka (I-SOFT MIONICA):</strong> Za podatke sopstvenih zaposlenih i lica uključenih u beta testiranje softvera, I-SOFT MIONICA nastupa kao Rukovalac podataka.
          </li>
        </ul>
      </Section>

      <Section title="2. Koje podatke prikupljamo i obrađujemo">
        <ul className="list-disc pl-5 space-y-2 text-sm">
          <li><strong>Zaposleni u kompaniji I-SOFT MIONICA:</strong> Ime, email adresa i profilna fotografija (prikupljeni putem Google Sign-In autentifikacije isključivo za pristup administrativnom panelu).</li>
          <li><strong>Zaposleni kod Klijenata (čitači, administratori, dispečeri):</strong> Pristupni kredencijali, email adrese, kao i tehnički podaci o uređaju u svrhu slanja notifikacija (Push token uređaja, verzija mobilne aplikacije i tip platforme — Android/iOS).</li>
          <li><strong>Krajnji korisnici usluga Klijenata (potrošači):</strong> Identifikacioni podaci i podaci o potrošnji (generisani i uneti isključivo od strane Klijenata).</li>
          <li><strong>Beta testeri aplikacije:</strong> Email adrese osoba zaduženih za interna (Play Store) i TestFlight (App Store) testiranja mobilne aplikacije.</li>
          <li><strong>Podaci o lokaciji:</strong> Adrese unesene u sistem (npr. adrese vodomera) koje se šalju eksternim servisima radi prikazivanja na mapi i pretvaranja u geografske koordinate (geocoding).</li>
        </ul>
      </Section>

      <Section title="3. Pravni osnov i svrha obrade">
        <ul className="list-disc pl-5 space-y-2 text-sm">
          <li><strong>Izvršenje ugovora i pružanje usluge:</strong> Omogućavanje funkcionalnosti aplikacije za Klijente, autentifikacija korisnika, isporučivanje radnih naloga čitačima i upravljanje bazom potrošača.</li>
          <li><strong>Pristanak (Saglasnost):</strong> Za lica koja dobrovoljno učestvuju u beta testiranju naših aplikacija.</li>
          <li><strong>Legitimni interes:</strong> Osiguranje bezbednosti, obrada povratnih informacija o dostavi e-pošte (bounces/webhooks) i stabilnosti IT infrastrukture.</li>
        </ul>
      </Section>

      <Section title="4. Deljenje podataka i servisi trećih lica">
        <p className="text-sm">Vaši podaci se dele isključivo u meri u kojoj je to neophodno za rad aplikacije sa sledećim pouzdanim servisima:</p>
        <ul className="list-disc pl-5 space-y-2 text-sm">
          <li>
            <strong>Slanje sistemskih e-mailova (Amazon SES):</strong> Za slanje autentifikacionih linkova i obaveštenja sa adrese <code className="bg-gray-100 px-1.5 py-0.5 rounded text-xs">noreply@waterworks.rs</code> koristimo servis Amazon Simple Email Service (Amazon SES). Statusi dostave i neuspešna slanja (bounces) obrađuju se putem webhooks-a.
          </li>
          <li>
            <strong>Push notifikacije (Expo, Apple, Google Firebase):</strong> Za dostavu obaveštenja na mobilne uređaje koristimo Expo Push servis, koji podatke (push token i verziju aplikacije) prosleđuje Apple APNs (za iOS) i Google Firebase Cloud Messaging (FCM) uslugama (za Android).
          </li>
          <li>
            <strong>Geolokacija i Mape:</strong> Google Maps SDK &amp; Geocoding API na Android/web platformi, odnosno Apple Maps (MapKit) na iOS uređajima.
          </li>
          <li>
            <strong>Google servisi (Google LLC):</strong> Google Sign-In za admin panel, Google Cloud Identity Groups API za Play Store testere i Google Drive (EU Region) isključivo za čuvanje rezervnih kopija (backup).
          </li>
          <li>
            <strong>Apple servisi (Apple Inc.):</strong> App Store Connect API za upravljanje email adresama TestFlight beta testera.
          </li>
          <li>
            <strong>Infrastruktura i hosting (Hetzner):</strong> Svi podaci se skladište i obrađuju na serverima kompanije Hetzner Online GmbH u Nemačkoj (Evropska Unija).
          </li>
        </ul>
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-900">
          <strong>Napomena:</strong> Platforma ne koristi servise za procesiranje platnih kartica, slanje SMS poruka, eksterne alate za marketinšku analitiku niti servise za automatsko praćenje grešaka (npr. Sentry, Stripe, Twilio).
        </div>
      </Section>

      <Section title="5. Skladištenje i bezbednost podataka">
        <p className="text-sm">Baza podataka platforme (PostgreSQL) se nalazi na serverima provajdera Hetzner u datacentru u Nemačkoj. Primenjujemo striktne tehničke i organizacione mere zaštite:</p>
        <ul className="list-disc pl-5 space-y-2 text-sm">
          <li><strong>Enkripcija u tranzitu (Encryption in transit):</strong> Svi podaci koji se razmenjuju između korisničkih aplikacija, eksternih servisa i servera kriptovani su modernim TLS/SSL protokolima visoke enkripcije.</li>
          <li><strong>Enkripcija u mirovanju (Encryption at rest):</strong> Svi podaci uskladišteni na diskovima servera i u bazi podataka, kao i rezervne kopije (backup), zaštićeni su enkripcijom u mirovanju.</li>
          <li><strong>Zaštita lozinki i pristupnih tokena:</strong> Korisničke lozinke se čuvaju u hešovanom (nepovratno šifrovanom) obliku koristeći industrijske standarde (bcrypt), dok se aktivacija naloga oslanja na vremenski ograničene jednokratne linkove.</li>
        </ul>
      </Section>

      <Section title="6. Prenos podataka u inostranstvo">
        <p className="text-sm">
          Primarno mesto skladištenja i obrade svih podataka su serveri kompanije Hetzner u <strong>Nemačkoj (EU)</strong>, dok se rezervne kopije čuvaju u okviru <strong>EU regiona na Google Drive infrastrukturi</strong>. Nemačka i Evropska Unija pružaju primeren nivo zaštite podataka o ličnosti u skladu sa članom 64. ZZPL. Pojedini servisi navedeni u odeljku 4 (Apple APNs, Google FCM, Google Maps/Geocoding, App Store Connect) mogu obrađivati podatke i van EU — takvi prenosi se oslanjaju na standardne ugovorne klauzule ili odgovarajuće mehanizme zaštite tih provajdera.
        </p>
      </Section>

      <Section title="7. Prava lica na koja se podaci odnose">
        <p className="text-sm">U skladu sa Zakonom (ZZPL), lica čiji se podaci obrađuju imaju sledeća prava:</p>
        <ul className="list-disc pl-5 space-y-1.5 text-sm">
          <li>Pravo na informisanje i pristup svojim podacima o ličnosti.</li>
          <li>Pravo na ispravku, dopunu i brisanje podataka (&quot;pravo na zaborav&quot;).</li>
          <li>Pravo na ograničenje obrade i pravo na prenosivost podataka.</li>
          <li>Pravo na prigovor Rukovaocu obrade.</li>
          <li>Pravo na podnošenje pritužbe <em>Povereniku za informacije od javnog značaja i zaštitu podataka o ličnosti RS</em>.</li>
        </ul>
      </Section>

      <Section title="8. Kontakt informacije">
        <p className="text-sm">
          Za sva pitanja o ovoj politici, zahteve u vezi sa podacima ili prigovore, možete se obratiti nosiocu platforme:
        </p>
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 text-sm space-y-1">
          <p className="font-semibold text-gray-900">I-SOFT MIONICA</p>
          <p>Adresa: Kneza Jovice Milutinovića 38, 14242 Mionica</p>
          <p>PIB: 109319817</p>
          <p>Matični broj: 64091034</p>
          <p>Email: podrska@waterworks.rs</p>
        </div>
      </Section>
    </>
  )
}
